import { render, staticRenderFns } from "./Statistics2.vue?vue&type=template&id=280d35da&scoped=true&"
import script from "./Statistics2.vue?vue&type=script&lang=js&"
export * from "./Statistics2.vue?vue&type=script&lang=js&"
import style0 from "./Statistics2.vue?vue&type=style&index=0&id=280d35da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d35da",
  null
  
)

export default component.exports